export default __webpack_public_path__ + "static/media/offroad250000.e4dffb60.jpg";